module.exports = __webpack_public_path__ + "img/neotag-product6.f339b5ad.jpg";